import dynamic from "next/dynamic";
import React   from "react";

const AdSlot = dynamic ( () => import ( "_components/features/ads/slot" ) );

const TestAd = () => {
	return (
		<AdSlot
			id   = "gpt-passback"
			path = { "/22991961619/home_page_feed_native_banner_web" }
			size = { [ "fluid" ] }
		/>
	);
};

export default TestAd;
